import React, { memo } from 'react';

import { Typography } from 'antd';

import ClipboardField from '../../ClipboardField';
interface IProps {
  urlSun: string;
  urlChk: string;
}

const LinksClipBoard = ({ urlSun, urlChk }: IProps) => {
  const hasCampaing = urlSun.toLowerCase().includes('edzz.la') || urlChk.toLowerCase().includes('edzz.la');
  return (
    <>
      {urlChk && (
        <div>
          <Typography.Text strong className='block'>
            {hasCampaing ? 'URL Gerada:' : 'URL Eduzz Checkout Elements:'}
          </Typography.Text>

          <ClipboardField value={urlChk} />
        </div>
      )}

      <div>
        <Typography.Text strong className='block'>
          {hasCampaing ? 'URL Gerada:' : 'URL Eduzz Checkout:'}
        </Typography.Text>

        <ClipboardField value={urlSun} />
      </div>
    </>
  );
};

export default memo(LinksClipBoard);
